import { withDisplayName } from '@hocs/with-display-name'
import React from 'react'

const DefaultComponent: Utils.EntryFC<Queries.EntryFragment> = ({
  content,
}) => {
  if (process.env.NODE_ENV === 'development') {
    console.log('Default Component triggered for :')
    console.log(content)
  }

  return <></>
}

export default withDisplayName(DefaultComponent, 'DefaultComponent')
